import Vue from "vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import EmptyLayout from "@/layouts/EmptyLayout.vue";

Vue.component("default-layout", DefaultLayout);
Vue.component("empty-layout", EmptyLayout);